import AddEditDialog from "../UI/AddEditDialog";
import fields from "../../Utils/Fields/businessDetailsFields";
import endpoint from "../../Utils/endpoint";

const AddEditBusinessDetailsDialog = ({
  openDialog,
  afterClose = () => {},
  dialogMode,
  patchData,
}) => {
  return (
    <AddEditDialog
      openDialog={openDialog}
      title="Bedrijfsgegevens"
      fields={fields}
      afterClose={afterClose}
      width="900px"
      endpoint={endpoint.businessDetails}
      dialogMode={dialogMode}
      patchData={patchData}
    />
  );
};

export default AddEditBusinessDetailsDialog;
